import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidCoffeeIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 19H3c-.6 0-1 .4-1 1s.4 1 1 1h18c.6 0 1-.4 1-1s-.4-1-1-1ZM9 17h4c2.8 0 5-2.2 5-5v-1h1c1.7 0 3-1.3 3-3s-1.3-3-3-3h-1V4c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v8c0 2.8 2.2 5 5 5Zm9-10h1c.6 0 1 .4 1 1s-.4 1-1 1h-1V7Z"/>
  </SvgIcon>
}

export default SolidCoffeeIcon
